import { AnchorXDTO, AnchorYDTO } from '@/model';
import { CSSProperties } from 'react';
import { alignItemAnchorYMap, justifyItemAnchorXMap } from '@/components';
import { theme } from '@style/theme';
import { Box, styled } from '@mui/system';
import { Button } from '@mui/material';
import { TreeItem } from '@mui/x-tree-view';

export const layerImageWrapperDivStyle = (
  anchorX: AnchorXDTO,
  anchorY: AnchorYDTO,
): CSSProperties => ({
  display: 'flex',
  justifyContent: justifyItemAnchorXMap.get(anchorX) || 'flex-start',
  alignItems: alignItemAnchorYMap.get(anchorY) || 'flex-start',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  position: 'relative',
});

export const layerImageStyle: CSSProperties = {
  objectFit: 'contain',
  maxWidth: '100%',
  maxHeight: '100%',
};

export const settingPanelStyle: CSSProperties = {
  position: 'absolute',
  top: '-55px',
  right: '5px',
  display: 'flex',
  padding: '5px 30px',
  backgroundColor: 'white',
  borderRadius: 36,
  zIndex: 10,
  border: theme.border.light,
  boxShadow:
    '0px 0px 0px 1px rgba(64, 87, 109, 0.04), 0px 6px 20px -4px rgba(64, 87, 109, 0.3)',
};

export const toolBarStyle: CSSProperties = {
  width: '100%',
  minHeight: '55px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
};

export const centeredBox = (gap: string = '8px'): CSSProperties => ({
  display: 'flex',
  alignItems: 'center',
  gap: gap,
});

export const StatusIndicator = styled('div')<{ unsaved: boolean }>(() => ({
  width: '20px',
  height: '20px',
  borderRadius: '50%',
  backgroundColor: 'transparent',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const BackButton = styled(Button)({
  color: 'white',
  '&:hover': {
    color: theme.colors.primary,
  },
});

export const OutlinedButton = styled(Button)<{ disabled: boolean }>(({ disabled }) => ({
  border: '1px solid',
  borderColor: 'rgb(241 241 241 / 30%)',
  backgroundColor: disabled ? 'rgba(255, 255, 255, 0.12)' : 'transparent',
  borderRadius: '10px',
  color: disabled ? 'rgb(241 241 241 / 14%)' : theme.colors.textLight,
  transition: 'background-color .1s linear, border-color .1s linear, color .1s linear',
  '&:hover': {
    border: '1px solid',
    borderColor: 'rgb(241 241 241 / 30%)',
    backgroundColor: disabled ? 'rgba(255, 255, 255, 0.12)' : 'rgb(241 241 241 / 14%)',
  },
}));

export const ContainedButton = styled(Button)({
  backgroundColor: theme.colors.buttonHover,
  color: theme.colors.main,
  borderRadius: '10px',
  '&:hover': {
    backgroundColor: theme.colors.primaryHover,
    boxShadow: theme.BOX_SHADOW.BUTTON_HOVER,
  },
});

export const ControlPanelContainer = styled(Box)({
  minHeight: 352,
  minWidth: 250,
  marginTop: '40px',
});

export const ElementGroupTreeItem = styled(TreeItem)({
  '& .MuiCollapse-wrapperInner': {
    display: 'flex',
  },
  '& .MuiTreeItem-iconContainer': {
    width: 0,
    minWidth: 0,
    padding: 0,
    marginRight: 0,
  },
});

export const ElementGridBox = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '16px',
  width: '100%',
  justifyContent: 'center',
});

export const ElementTreeItem = styled(TreeItem)({
  width: '100%',
  '& .MuiTreeItem-content': {
    padding: 0,
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  '& .MuiTreeItem-label': {
    width: '100%',
    padding: 0,
  },
});

export const scrollableContainerStyles = {
  elements: {
    height: 400,
    padding: '10px 38px 5px 0px',
  },
  layers: {
    height: 350,
    padding: '10px 10px 5px 0px',
  },
} as const;

export const elementContainer = (): CSSProperties => ({
  width: '100%',
  textAlign: 'center',
  backgroundColor: '#f2f3f7',
  borderRadius: '5px',
  padding: '8px',
  border: '1px solid lightgray',
  display: 'flex',
  flexDirection: 'column',
  paddingTop: '8px',
  justifyContent: 'center',
  height: '100%',
  alignItems: 'center',
});

export const elementNameContainer = (): CSSProperties => ({
  overflow: 'auto',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  wordBreak: 'break-word',
  maxWidth: '100%',
  padding: '0 8px',
});
